import { TeamsClientWrapper } from './TeamsClientWrapper';

export default function TeamsPage() {
  // You can fetch initial data here if needed, for now passing empty
  return (
    <div className="space-y-6">
      <TeamsClientWrapper />
    </div>
  );
}